import moment from 'moment';
import _ from 'lodash';

export default {

    currentSearchTerm: (state, getters) => {
        return state.searchTerm;
    },
    currentSite: (state, getters) => {
        return state.selectedSite;
    },
    darkMode() {
        return false;
    },
    defaultLanguage() {
        return 'fr';
    },
    displayAppSearchBar() {
        return false;
    },

    displayAuthFullOverlay(state, getters, rootState, rootGetters) {
        return !rootGetters.userIsAuthenticated;
    },
    displayChooseEntityFullOverlay() {
        // DO NOT DISPLAY view Choose Entity
        return false;
    },

    displayLoadingFullOverlay(state, getters, rootState, rootGetters) {
        return !rootGetters.modelsUnscopedLoaded;
    },
    enableGroupsAdministration() {
        return true;
    },
    enableUsersAdministration() {
        return true;
    },
    enablePermissionAdministration() {
        return true;
    },
    enableGroupsSideBarMenu() {
        return true;
    },
    enableUsersSideBarMenu() {
        return true;
    },
    enableDownloadCsvGroups() {
        return false;
    },
    enableDownloadCsvUsers() {
        return false;
    },
    enableRegister() {
        return false;
    },
    enableResetPassword() {
        return false;
    },
    enableSidebarCollapse() {
        return false;
    },
    enableLoginByEmail() {
        return false;
    },
    enableCreateUser() {
        return false;
    },
    enableCreateGroup() {
        return false;
    },
    enableDeleteGroup() {
        return true;
    },
    enableManageNotifications() {
        return false;
    },
    enableManageOtherUsersNotifications() {
        return false;
    },

    // Pictures
    // loginImage() {
    //     return '/static/img/loginImage.jpg';
    // },
    // backgroundFile1() {
    //     return '/static/img/backgroundFile1.jpg';
    // },
    // backgroundFile2() {
    //     return '/static/img/backgroundFile2.jpg';
    // },
    logoFile() {
        return '/static/images/logo_file.png';
    },
    // logoFileTopHeader() {
    //     return '/static/img/logoFileTopHeader.png';
    // },
    // logoFileBackgroundColor(/*state, getters, rootState*/) {
    //     return 'transparent';
    // },
    // logoFileTopHeader(/*state, getters*/) {
    //     // return getters.currentEntity.logo_file_topHeader;
    //     return ImageBase64.logoFileTopHeader;
    // },
    // logoFileTopHeaderBackgroundColor(/*state, getters*/) {
    //     return '#333';
    // },
    isApiValoUsed(state) {
        return state.apiValoAuth;

    },
    defaultDateFormat: () => (date) => {
        return moment(date).format('DD/MM/YYYY');
    },
    currentArea: (state) => {
        return state.currentArea;
    },
    energyMetersSite: (state) => {
        return state.energyMeters
            .map(meterData => meterData.usedIn.includes('site') ? meterData : null)
            .filter(meter => meter !== null);
    },
    energyMetersArea: (state) => {
        return state.energyMeters
            .map(meterData => meterData.usedIn.includes('area') ? meterData : null)
            .filter(meter => meter !== null);
    },
    energyMetersEquipment: (state) => {
        return state.energyMeters
            .map(meterData => meterData.usedIn.includes('equipment') ? meterData : null)
            .filter(meter => meter !== null);
    },
    energyMeterIcon: (state) => (value) => {
        return state.energyMeters.find((meterData) => meterData.key === value).icon
    },
    energyMetersPrefix: (state) => (value) => {
        if (value === '') {
            return '-';
        }
        return state.energyMeters.find((meterData) => meterData.key === value).prefix
    },
    currentEquipment: (state) => {
        return state.currentEquipment;
    },
    currentEnergyMeterNames: (state) => {
        return state.currentEnergyMeterNames
    },
    allMeasureFilesLoaded: (state) => {
        return state.allMeasureFilesLoaded
    },
    allMeasureFilesUids: (state) => {
        return state.allMeasureFilesUids
    },
    selectedItem: (state) => {
        return state.selectedItem
    },
    hasSimulation: (state) => {
        return state.currentSimulation !== null && state.currentSimulation !== undefined;
    },
    currentSimulation: (state) => {
        return state.currentSimulation
    }
};



// WEBPACK FOOTER //
// ./src/store/getters.js